import FlexPane from './_flex-pane.js'
import BetBonusPromotions from './_bet-bonus-promotions.js'
import LabeledBet from './_labeled-bet.js'

export default {
  name: 'SystemBetsList',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
        separator: {
          style: {
            margin: '0 8px',
            size: '1px',
          },
        },
      },
    },
    betBonusPromotions: {
      configSet: BetBonusPromotions,
      configValues: {
        container: {
          style: {
            padding: '0 8px 8px 8px',
          },
        },
        disabledContainer: {
          style: {
            padding: '0 8px 8px 8px',
          },
        },
      },
    },
    labeledBet: {
      configSet: LabeledBet,
      configValues: {},
    },
    oddsBoostWrapper: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '0 8px 8px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
